import requests from "/src/utils/requests"

const getTotalData = function(params) {
	return requests({
		url: `/coreData`,
		method: "get",
		params: params
	})
}

const getShopsRank = function(params) {
	return requests({
		url: `/turnoverRank`,
		method: "get",
		params: params
	})
}

const getTurnoverOrder = function(params) {
	return requests({
		url: `/getWeekData`,
		method: "get",
		params: params
	})
}


const getGoodsRanking = function(params) {
	return requests({
		url: `/turnoverItemRank`,
		method: "get",
		params: params
	})
}

const getAreaRanking = function(params) {
	return requests({
		url: `/turnoverRankArea`,
		method: "get",
		params: params
	})
}

const shopOpeningPlan = function(params) {
	return requests({
		url: `/branch/plan`,
		method: "get",
		params: params
	})
}


const getMapData = function(params) {
	return requests({
		url: `/dataArea`,
		method: "get",
		params: params
	})
}


const getAllAreas = function(params) {
	return requests({
		url: `/area`,
		method: "get",
		params: params
	})
}

const getPayawayList = function(params) {
	return requests({
		url: `/getPayAmt`,
		method: "get",
		params: params
	})
}




export default {
	getTotalData,
	shopOpeningPlan,
	getShopsRank,
	getGoodsRanking,
	getTurnoverOrder,
	getAllAreas,
	getPayawayList,
	getAreaRanking,
	getMapData
}